import axios from '../../axios';

export type ServiceResponse = {
  id: string;
  clientCode: string;
  clientName: string;
  taxId: string;
  balance: string;
  reconciliationStatus: string;
  documentCount: string;
  type: string;
};

export default async function getDemands(caseRecordType: string): Promise<ServiceResponse[]> {
  const res = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/task?caseRecordType=${caseRecordType}&type=COPILOT`
  );
  return res.data;
}
